// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1PM6k","location":"Header_location__2_4At"};